var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.8328V22H6.16724L18.4634 9.70386L14.2961 5.53662L2 17.8328Z",
    fill: "#0077C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 22V17.8328L14.2961 5.53662L18.4634 9.70386L6.16724 22H2ZM5.75303 21L17.0492 9.70387L14.2961 6.95084L3 18.247V21H5.75303Z",
    fill: "#0077C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6746 4.91983L19.0797 2.32504C18.6463 1.89165 17.9407 1.89165 17.5073 2.32504L15.4736 4.35866L19.6409 8.5259L21.6745 6.49229C22.108 6.05889 22.108 5.35322 21.6746 4.91983Z",
    fill: "#0077C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlueIcon);
export default __webpack_public_path__ + "static/media/EditBlueIcon.a188fb140509922e47ce4d683b9cb0cc.svg";
export { ForwardRef as ReactComponent };